import './core/wasm_exec';

const appName = 'APPUI';

let goInstance = null;
let wasmModule = null;

/**
 * Initializes WebAssembly module.
 * Sets up polyfill if necessary and runs the WASM instance.
 */
export const initWASM = async () => {
    try {
        // Polyfill for WebAssembly.instantiateStreaming
        if (!WebAssembly.instantiateStreaming) {
            WebAssembly.instantiateStreaming = async (resp, importObject) => {
                const source = await (await resp).arrayBuffer();
                return await WebAssembly.instantiate(source, importObject);
            };
        }

        const initialize = async () => {
            const Go = window['Go'];
            if (!Go) {
                throw new Error('Go runtime is not available in the global scope.');
            }

            const wasmPath = (await import('./core/lib.wasm')).default;
            const go = new Go();
            const result = await WebAssembly.instantiateStreaming(fetch(wasmPath), go.importObject);

            const {instance, module} = result;
            go.run(instance);

            goInstance = go;
            wasmModule = module;

            return result;
        };

        return await initialize();
    } catch (error) {
        return false;
    }
};

/**
 * Resets the WebAssembly instance by re-instantiating it.
 */
export const resetWASMInstance = async () => {
    try {
        if (!wasmModule || !goInstance) {
            throw new Error('WASM module or Go instance is not initialized.');
        }

        const instance = await WebAssembly.instantiate(wasmModule, goInstance.importObject);
        goInstance.run(instance); // Re-run the instance
    } catch (error) {
        console.error('Failed to reset WASM instance:', error);
        throw error;
    }
};

/**
 * Retrieves the key from the global scope.
 * Assumes a `getKey` function exists globally.
 */
export const getKey = () => {
    try {
        const getKeyFunction = window['getKey'];
        if (typeof getKeyFunction !== 'function') {
            console.log('getKey is not defined or not a function in the global scope.');
            return false;
        }

        return getKeyFunction();
    } catch (error) {
        console.error('Failed to get key:', error);
        throw error;
    }
};

/**
 * Returns the UI API details including ID and Key.
 */
export const getUIAsapi = () => {
    try {
        return {
            ID: appName,
            Key: getKey()
        };
    } catch (error) {
        console.error('Failed to get UI Asapi:', error);
        throw error;
    }
};
